import React, { useState, useEffect, useRef } from 'react';
import Head from 'next/head'
import { useRouter } from 'next/router';
import Layout from '../../components/layout'
import PaginatedList from '../../components/GenePaginatedList';
import NProgress from 'nprogress';
import { Heading, Text, Divider, InputGroup, InputLeftElement, Input, Center, Flex, Box, VStack, useColorModeValue} from "@chakra-ui/react"
import { FiSearch } from "react-icons/fi";
import useSWR, { SWRConfig } from "swr";
import GeneFilters from '../../components/GeneFilters';
import Container from '../../components/Container';

const fetcher = (url, token) =>
  fetch(url, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json', token }),
    // credentials: 'same-origin',
  }).then((res) => res.json())

// const API = 'http://localhost:3000/api/genes';


// export const getServerSideProps = async() => {
//   const genes = await fetcher(API)
  
//   return { 
//     props: {
//       fallback: {
//         [API]: genes
//       }
//   }
// }
// }

function GenesData() {
  const router = useRouter();
  const ref = useRef()
  const { data, error, isValidating } = useSWR(`/api${router.asPath}`,fetcher, {dedupingInterval: 15000, initialData: ref.current ? ref.current : undefined, revalidateOnFocus: false })
  // const { data, error, isValidating } = useSWR(`/api${router.asPath}`, {dedupingInterval: 15000, initialData: ref.current ? ref.current : undefined, revalidateOnFocus: false});
  // console.log(data);
    if (data) {
      ref.current = data;
    }

  return (
    <PaginatedList router={router} data={data} error={error} isValidating={isValidating} />
  );
}

export default function Genes({fallback}) {
  const [pageIndex, setPageIndex] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();

  useEffect(() => {
    if (router.query.search) {
      setSearchQuery(router.query.search)
    }
    else {
      setSearchQuery('')
    }
  }, [router])

  const onSubmit = evt => {
    evt.preventDefault();
    if (searchQuery != '') {
      router.push({
        pathname: '/genes',
        query: { search: encodeURI(searchQuery) },
    });
    }
    else {
      router.push({
        pathname: '/genes',
    });
    }
    
  };
  
  const bg = useColorModeValue("white", "darkGray.900")
  const inputBg = useColorModeValue("gray.100", "neutral.1000")
  const inputText = useColorModeValue("black", "white")
  const borderColor = useColorModeValue("gray.200", "neutral.900")
  const inputPlaceholderColor = useColorModeValue("darkGray.800", "darkGray.500")
  
  const onChange = evt => setSearchQuery(evt.target.value);
  
  return (
      <>
      <Layout>
      <Head>
        <title>Genes</title>
        <meta name="description" content="Discover human genes affecting thousands of conditions"></meta>
        <meta name="robots" content="index, follow"></meta>
      </Head>
      <Container>
      <Flex px={0} py={4} mx="auto">
        <VStack
        w={'full'}
        justify={'center'}
        >
        <Center>
      <Heading as="h1" fontSize="5xl">Genes</Heading>
      </Center>
      <Center>
      <Text as="h2" fontSize="2xl" mt={5} align="center">Discover human genes affecting<br/> thousands of conditions</Text>
      </Center>
      <Center>
  
        </Center>
            </VStack>
            </Flex>
            <Divider orientation="horizontal" mt={4} mb={2} borderColor={borderColor}/>
    
    <Box maxW={["100%","100%","100%","100%"]} mb={100}>
      <Flex
        direction={['column-reverse', 'column-reverse', 'row', 'row']}
        w="full"
        justify="space-between"
        justifyContent="center"
        maxW={["100%", "100%", "100%", "100%", "85%"]}
        m="0 auto"
      >
        <Box p={4} w={["100%","100%","60%","55%"]}>
        <SWRConfig value={{ fallback }}>
          <GenesData />
        </SWRConfig>
          {/* <PaginatedList pageIndex={pageIndex} props={props}/> */}
        </Box>
        {/* <Spacer /> */}
        <Box p={4} w={["100%","100%","40%","30%"]}>
                <Box mb={5}>
                <Heading as="h5" fontSize={14} size="s" mb="2" fontWeight="normal">Search a Gene</Heading>
          <form onSubmit={onSubmit}>
                <InputGroup>
          <InputLeftElement
            pt={0}
            pl={0}
            fontSize={"18px"}
            pointerEvents="none"
          >
            <FiSearch />
            </InputLeftElement>
          <Input 
            pl={10} 
            color={inputText} 
            size="md" 
            placeholder="search a gene (e.g. BRCA2)" 
            _placeholder={{ color: inputPlaceholderColor }}
            // value={searchQuery || router.query.search}
            value={searchQuery}
            onChange={onChange} 
            borderRadius={8} 
            borderColor={"gray.500"} 
            border="0px" 
            bgColor={inputBg}/>
        </InputGroup>
        </form>
        <Divider orientation="horizontal" mt={5} borderColor={borderColor}/>
        </Box>
          <GeneFilters instanceId={"data"}/>
        </Box>
      </Flex>
    </Box>
    {/* {pageIndex !== props.genes.total_pages ? <div style={{ display: 'none' }}><PaginatedList pageIndex={pageIndex + 1} props={props}/></div> : null} */}
  </Container>
</Layout>
    </>
      )
  }